import { action } from '@play-co/replicant';
import createActions from '../config/actions/createActions';
import { type PetSpeciesID, type PetEvolutionStage } from '../pet';
import ab from '../ruleset/ab';
import { DemoTestBucket } from 'src/lib/getDemoState';

export const demoActions = createActions({
  /**
   * Continue demo game on real environment
   */
  resumeGame: action(
    (
      state,
      {
        demoBucketId,
        petName,
        evolution,
        tos,
      }: {
        demoBucketId: string;
        petName: string;
        evolution: readonly {
          species: PetSpeciesID;
          stage: PetEvolutionStage;
          timestamp: number;
        }[];
        tos: { [key: string]: { acceptedAt: number } } | undefined;
      },
      api,
    ) => {
      const species = evolution[0]?.species ?? 'ball';

      // Recover state from demo state
      switch (demoBucketId) {
        case 'control':
          // Do nothing
          break;
        case 'afterFirstPuzzle':
          // Match2
          state.match2.level = 2;
          state.match2.lastLevel = 1;
          state.match2.winLadderStep = 2;

          // Tutorial flags
          state.tutorial.match2 = true;

          // Inventory
          state.inventory.points = 60;
          break;
        case 'afterTutorial':
          // Match2
          state.match2.level = 3;
          state.match2.lastLevel = 2;

          // Pet
          state.pet.name = petName;
          state.pet.evolutions = [
            {
              species: species === 'starball' ? 'starball' : 'ball',
              stage: 'baby',
              timestamp: api.date.now(),
            },
          ];
          state.pet.attributes = {
            stomach: { value: 99, lastUpdatedAt: api.date.now() },
            love: { value: 99, lastUpdatedAt: api.date.now() },
            toothAcidity: { value: 5, lastUpdatedAt: api.date.now() },
            dirtiness: { value: 0, lastUpdatedAt: api.date.now() },
            urine: { value: 0, lastUpdatedAt: api.date.now() },
          };

          // Inventory
          state.inventory.points = 315;
          state.inventory.energy = 5;

          // Tutorial flags
          state.tutorial.match2 = true;
          state.tutorial.basicGameplayShown = true;
          state.tutorial.chatWithPetsShown = true;
          state.tutorial.careForPetsShown = true;

          // Care
          state.care.careActionCount = 2;

          // Encyclopedia
          state.encyclopedia.speciesState =
            species === 'starball'
              ? {
                  starball: 'unlocked',
                }
              : {
                  ball: 'unlocked',
                };
          state.encyclopedia.speciesNotification =
            species === 'starball' ? { starball: true } : { ball: true };
          break;
      }

      // Set tos date
      if (state.platformStorage && tos) {
        state.platformStorage.tos = tos;
      }

      // Assign user to test for analytics
      if (demoBucketId) {
        api.abTests.assign(
          ab.tests.TEST_DEMO_MODE,
          demoBucketId as DemoTestBucket,
        );
      }
    },
  ),
});
